









































import { Component, Vue, Prop } from 'vue-property-decorator';
import { ButtonType } from '@getaccept/lib-ui';

@Component({
  data: () => ({ ButtonType }),
})
export default class RejectModal extends Vue {
  @Prop() isRejected: boolean;

  reasonText = '';
  isLoading = false;

  get headerText(): string {
    if (this.isRejected) {
      this.isLoading = true;
      return this.$t('document-successfully-rejected!').toString();
    }
    return this.$t('reject-document').toString();
  }

  handleReject() {
    this.isLoading = true;
    this.$emit('rejectDocument', this.reasonText);
  }

  handleClose() {
    this.$emit('close');
  }
}
